import a from "./highrise1183.mjs";
import { createHighRiseStrings as n } from "./highrise1286.mjs";
import { createGHLUIStrings as i } from "./highrise1270.mjs";
import { createNonTranslatedStrings as c } from "./highrise1300.mjs";
import { dateLocaleMap as f } from "./highrise1255.mjs";
const h = (e) => {
  const r = n("en-US"), t = n(e), o = c(e), s = i(e);
  return a({}, r, s, t, o, {
    name: e
  });
}, l = (e) => f[e], m = [
  "hr",
  "da",
  "nl",
  "en-US",
  "fi",
  "fr-CA",
  "fr-FR",
  "de",
  "hu",
  "it",
  "no",
  "pt-BR",
  "pt-PT",
  "es",
  "sv"
], L = (e) => {
  if (!e)
    return "en-US";
  if (typeof e == "string" && e.includes("_")) {
    console.warn(`Deprecated used of '_' in the language '${e}', please change to use hyphen '-'.`);
    const r = e.replace("_", "-");
    return m.includes(r) ? r : (console.warn(`Invalid language '${r}', falling back to 'en-US'`), "en-US");
  }
  return e;
};
export {
  l as createDateLocale,
  h as createLocale,
  L as getTransformedLanguage
};
